import React, { useCallback, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { ExpandToggleButton, ExpandToggle as ExpandToggleIcon } from '../components/expand-toggle';
export const useExpandable = (canExpand, isRowExpandable) => {
    const { sizeUnit } = useTheme();
    const style = useMemo(() => ({
        width: sizeUnit * 8
    }), [sizeUnit]);
    return (hooks) => {
        hooks.visibleColumnsDeps.push((deps) => [...deps, canExpand]);
        hooks.visibleColumns.push((columns) => {
            return canExpand
                ? [
                    {
                        id: 'expander',
                        Header: () => null,
                        isVirtualColumn: true,
                        disableFilters: true,
                        disableResizing: true,
                        disableSortBy: true,
                        disableGroupBy: true,
                        style,
                        Cell: ({ row }) => {
                            const isExpandable = isRowExpandable ? isRowExpandable(row) : true;
                            const toggle = useCallback((e) => {
                                e.stopPropagation();
                                isExpandable && row.toggleRowExpanded();
                            }, [row]);
                            return (React.createElement(ExpandToggleButton, { ...row.getToggleRowExpandedProps(), disabled: !isExpandable, onClick: toggle },
                                React.createElement(ExpandToggleIcon, { "$isOpen": row.isExpanded })));
                        },
                        className: 'invent-table-expander'
                    },
                    ...columns
                ]
                : columns;
        });
    };
};
